import React from "react";
import styles from "./settingsDrawerToggle.module.scss";
import { HelpTooltip } from "components/Common/HelpTooltip";
import { AlertCircle } from "lucide-react";

export const SettingsDrawerEntryWrapper = ({ label, helpTooltip, warning, children}) => {
  return (
    <div className={styles["toggle-container"]}>
      <div className={styles["label-container"]}>
        <div className={styles["label"]}>{label}</div>
        {helpTooltip && (
          <HelpTooltip position={"top-end"} width="300px">
            {helpTooltip}
          </HelpTooltip>
        )}
      </div>
      {warning && (
        <div className={styles["warning"]}>
          <AlertCircle /> {warning}
        </div>
      )}
      {children}
    </div>
  );
};
